/**
 * @description an object that link saved step in backend and state machine steps
 */
export const StepRelatedToAction: { [key: string]: string } = {
  'project.rent': 'INIT_RENT',
  'project.sale': 'INIT_SALE',
  'project.pro': 'INIT_PRO',
  'applicant.main_applicant': 'INIT_MAIN_APPLICANT',
  'applicant.co_candidat': 'INIT_CO_CANDIDAT',
  'applicant.professional': 'INIT_PROFESSIONAL',
  'applicant.need_guarantor': 'INIT_NEED_GUARANTOR',
  'applicant.verlingue_guarantor': 'INIT_VERLINGUE_GUARANTOR',
  'applicant.guarantor': 'INIT_GUARANTOR',
}

/**
 * @description Get Action based on a saved step
 * @returns string | false
 */
export const getActionAndApplicantFromStep = (
  step: string
): { action: string | undefined; applicant: string | undefined } => {
  const split = step.split('/')
  if (split[0] && StepRelatedToAction[split[0]]) {
    return {
      action: StepRelatedToAction[split[0]],
      applicant: split[1] || undefined,
    }
  }

  return {
    action: undefined,
    applicant: undefined,
  }
}
